import withStyles from "isomorphic-style-loader/lib/withStyles";
import React from "react";
import { withRouter } from "react-router-dom";
import { Button, Table } from "reactstrap";
import BaseInput from "../../../toolkit/baseInput";
import ModalFrame from "../../../toolkit/modalFrame";
import { handleRequestError } from "../../../utils/helpers";
import { getPersonByIdRequest, getPersonsRequest } from "../../actions/persons";
import s from "./styles.scss";

interface Props {
  isOpen: boolean;
  cancel: any;
  asociar: any;
}

enum SCREEN_MODES {
  SEARCHING,
  CREATING
}

interface State {
  searchFields: {
    nombre: string;
    apellido: string;
    apellidoMaterno: string;
  };
  personaID: string;
  selectedPartner: string;
  screenMode: SCREEN_MODES;
  loading: boolean;

  persons: any[];
}

class SearchPersonModal extends React.Component<Props, State> {
  state = {
    searchFields: {
      nombre: "",
      apellido: "",
      apellidoMaterno: ""
    },
    personaID: "",
    selectedPartner: null,
    screenMode: SCREEN_MODES.SEARCHING,

    loading: false,
    persons: []
  };

  componentDidUpdate() {}

  onChangeSearchFieldsFactory = fieldName => {
    return event => {
      const value = event.target.value;
      this.setState(state => {
        const searchFields = {
          ...state.searchFields,
          [fieldName]: value
        };

        return { ...state, searchFields };
      });
    };
  };

  searchClients = e => {
    e.preventDefault();
    const args = { ...this.state.searchFields };

    this.setState({ loading: true });

    if (this.state.personaID) {
      getPersonByIdRequest(this.state.personaID)
        .then(({ data }) => {
          this.setState({ persons: [{ ...data }] });
        })
        .catch(handleRequestError);
    } else {
      getPersonsRequest(args)
        .then(({ data }) => {
          this.setState({ persons: [...data] });
        })
        .catch(handleRequestError);
    }
    setTimeout(() => this.setState({ loading: false }), 1000);
    this.setState({ screenMode: SCREEN_MODES.SEARCHING });
  };

  onChangePersonaID = event => {
    const personaID = event.target.value;
    this.setState({ ...this.state, personaID });
  };

  selectPartner = id => {
    this.setState({ selectedPartner: id });
  };

  clear = () => {
    this.setState({
      searchFields: {
        nombre: "",
        apellido: "",
        apellidoMaterno: ""
      },
      personaID: "",
      selectedPartner: null,
      screenMode: SCREEN_MODES.SEARCHING,

      loading: false,
      persons: []
    });
  };

  getPersonsRender = () => {
    const personsToRender = [...(this.state.persons || [])];
    return personsToRender && personsToRender.length ? (
      <Table size="sm" hover className="table-borderless">
        <thead>
          <tr>
            <th>PersonaID</th>
            <th>Nombre</th>
            <th>Apellido P.</th>
            <th>Apellido M.</th>
            <th>Fecha de Nacimiento</th>
            <th>Teléfono</th>
            <th>Correo</th>
          </tr>
        </thead>
        <tbody>
          {" "}
          {personsToRender && personsToRender.length
            ? personsToRender.map(prospect => (
                <tr
                  className={s.partnerRow}
                  style={
                    prospect.personaId === this.state.selectedPartner
                      ? { backgroundColor: "rgba(0, 0, 0, 0.075)" }
                      : {}
                  }
                  onClick={() => this.selectPartner(prospect)}
                  key={prospect.personaId}
                >
                  <th scope="row">{prospect.personaId}</th>
                  <td>{prospect.nombre}</td>
                  <td>{prospect.primerApellido}</td>
                  <td>{prospect.segundoApellido}</td>
                  <td>{prospect.fechaNacimiento}</td>
                  <td>
                    {prospect.telefonos &&
                      prospect.telefonos.length &&
                      prospect.telefonos[0].numero}
                  </td>
                  <td>
                    {prospect.correosElectronicos &&
                      prospect.correosElectronicos.length &&
                      prospect.correosElectronicos[0].correo}
                  </td>
                </tr>
              ))
            : null}
        </tbody>
      </Table>
    ) : null;
  };

  render() {
    return (
      <ModalFrame
        title={"Buscar persona"}
        isOpen={this.props.isOpen}
        toggle={() => {
          this.clear();
          if (!!this.props.cancel) {
            this.props.cancel();
          }
        }}
        size="lg"
      >
        <div className={s.modalContainer}>
          <div className="h-100">
            <form className={s.basicDataClub}>
              <div className="form-row">
                <div className="col-md-2">
                  <BaseInput
                    label={"Persona Id"}
                    name="personaID"
                    type="text"
                    id="personaID"
                    placeholder="Persona Id"
                    value={this.state.personaID}
                    onChange={e => this.onChangePersonaID(e)}
                    disabled={
                      this.state.searchFields.apellido ||
                      this.state.searchFields.nombre
                    }
                  />
                </div>
                <div className="col">
                  <BaseInput
                    label={"* Nombre"}
                    name="nombre"
                    type="text"
                    id="nombre"
                    placeholder="Nombre"
                    value={this.state.searchFields.nombre}
                    disabled={this.state.personaID}
                    onChange={this.onChangeSearchFieldsFactory("nombre")}
                  />
                </div>
                <div className="col">
                  <BaseInput
                    label={"* A. Paterno"}
                    name="apellido"
                    type="text"
                    id="apellido"
                    placeholder="A. Paterno"
                    value={this.state.searchFields.apellido}
                    disabled={this.state.personaID}
                    onChange={this.onChangeSearchFieldsFactory("apellido")}
                  />
                </div>
                <div className="col">
                  <BaseInput
                    type="text"
                    label={"A. Materno"}
                    name="apellidoMaterno"
                    id="apellidoapellidoMaterno"
                    placeholder="A. Materno"
                    value={this.state.searchFields.apellidoMaterno}
                    disabled={this.state.personaID}
                    onChange={this.onChangeSearchFieldsFactory(
                      "apellidoMaterno"
                    )}
                  />
                </div>
                <div className="col-1">
                  <Button
                    className={`${s.buttonMarginTop} ${s.primaryButton} mt-4`}
                    onClick={e => this.searchClients(e)}
                    size="sm"
                    block
                    disabled={
                      (!this.state.personaID &&
                        !(
                          this.state.searchFields.apellido &&
                          this.state.searchFields.nombre
                        )) ||
                      this.state.loading
                    }
                  >
                    {!this.state.loading ? "Buscar" : "Espere"}
                  </Button>
                </div>
              </div>
            </form>
            <hr />
            {this.getPersonsRender()}
          </div>

          <form>
            <div className="form-row p-0 mb-3">
              <div className="col-1 float-right pr-0">
                <Button
                  className={`${s.buttonMarginTop} ${s.primaryButton} mt-4`}
                  onClick={e => {
                    e.preventDefault;
                    if (!!this.props.asociar) {
                      this.props.asociar({ ...this.state.selectedPartner });
                    }
                    this.clear();
                  }}
                  size="sm"
                  block
                  disabled={!this.state.selectedPartner}
                >
                  Asociar
                </Button>
              </div>
            </div>
          </form>
        </div>
      </ModalFrame>
    );
  }
}

export default withRouter(withStyles(s)(SearchPersonModal));
